import { utils, writeFile } from 'xlsx';

const SIN_DATO = '';
const SEDES_EXPORTACION = [
  'esam tarija 2',
  'esam camargo',
  'digital school cobija',
  'digital school tarija',
  'digital school camargo',
  'esam dbs tarija',
  'esam dbs cobija',
  'upi tarija sucursal',
  'upi dbs tarija',
  'upi dbs camargo',
  'upi dbs cobija',
];
const SEDES_EXPORTACION_NORMALIZADAS = SEDES_EXPORTACION.map(normalizarTexto);

function texto(valor) {
  if (valor === null || valor === undefined) return SIN_DATO;
  return valor;
}

function estadoInscripcionTexto(estado) {
  if (estado === 0 || estado === '0') return 'Pre inscrito';
  if (estado === 1 || estado === '1') return 'Inscrito';
  return `Otro: ${texto(estado)}`;
}

function modalidadTexto(modalidad) {
  const modalidades = {
    P: 'Presencial',
    V: 'Virtual',
    S: 'Semipresencial',
    E: 'E-learning',
  };

  return modalidad ? modalidades[modalidad] || modalidad : SIN_DATO;
}

function faseTexto(fase) {
  if (fase == 0) return 'NO APROBADO';
  if (fase == 1) return 'INSCRIPCIONES';
  if (fase == 2) return 'EN DESARROLLO';
  if (fase == 3) return 'CONCLUIDO';
  if (fase == 4) return 'ELABORACION TRABAJOS FINALES';
  if (fase == 5) return 'RECEPCION DE REQUISITOS DE TITULACION';
  if (fase == 6) return 'ARMADO CARPETAS';
  if (fase == 7) return 'PAGO ARANCELES';
  if (fase == 8) return 'PROCESO TITULACION';
  if (fase == 9) return 'CERTIFICADOS ENTREGADOS';
  if (fase == 10) return 'NO EJECUTADO';
  return `DESCONOCIDO: ${texto(fase)}`;
}

function normalizarTexto(valor) {
  return (valor || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function sedePermitida(programa) {
  const sede = normalizarTexto(programa.sede && programa.sede.nombre);

  return SEDES_EXPORTACION_NORMALIZADAS.some(nombreSede => sede.includes(nombreSede));
}

function nombreHojaBase(programa, indice) {
  const base = programa.nombre_compuesto || programa.codigo || `Programa ${programa.id || indice + 1}`;
  return base
    .replace(/[\\/?*[\]:]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 31) || `Programa ${indice + 1}`;
}

function nombreHojaUnico(programa, indice, usados) {
  const base = nombreHojaBase(programa, indice);
  let nombre = base;
  let contador = 2;

  while (usados[nombre]) {
    const sufijo = ` ${contador}`;
    nombre = `${base.slice(0, 31 - sufijo.length)}${sufijo}`;
    contador += 1;
  }

  usados[nombre] = true;
  return nombre;
}

function filaPrograma(programa, inscripcion = null) {
  const estudiante = inscripcion && inscripcion.estudiante ? inscripcion.estudiante : {};

  return {
    'ID programa': texto(programa.id),
    'Codigo programa': texto(programa.codigo),
    Programa: texto(programa.nombre_compuesto),
    Sede: texto(programa.sede && programa.sede.nombre),
    Universidad: texto(programa.universidad && programa.universidad.nombre),
    Gestion: texto(programa.gestion),
    Modalidad: modalidadTexto(programa.modalidad),
    'Fase ID': texto(programa.fase),
    Fase: faseTexto(programa.fase),
    'Fecha inicio': texto(programa.fecha_inicio),
    'Fecha fin': texto(programa.fecha_fin),
    'ID inscripcion': texto(inscripcion && inscripcion.id),
    'Estado inscripcion ID': texto(inscripcion && inscripcion.estado_ins),
    'Estado inscripcion': inscripcion ? estadoInscripcionTexto(inscripcion.estado_ins) : 'Sin inscripciones',
    'Estado administrativo ID': texto(inscripcion && inscripcion.estado_administrativo_id),
    'Fecha registro': texto(inscripcion && inscripcion.fecha_registro),
    Documento: texto(estudiante.num_doc),
    Nombres: texto(estudiante.nombres),
    'Primer apellido': texto(estudiante.pri_apellido),
    'Segundo apellido': texto(estudiante.seg_apellido),
    'Telefono 1': texto(estudiante.telefono1),
    'Telefono 2': texto(estudiante.telefono2),
    Email: texto(estudiante.email),
  };
}

function filasPrograma(programa) {
  const inscripciones = programa.inscripciones || [];

  if (inscripciones.length === 0) return [filaPrograma(programa)];

  return inscripciones.map(inscripcion => filaPrograma(programa, inscripcion));
}

export function exportarInscripcionesPorPrograma(programas, gestion) {
  const workbook = utils.book_new();
  const usados = {};
  const programasPermitidos = programas.filter(sedePermitida);

  programasPermitidos.forEach((programa, indice) => {
    const hoja = utils.json_to_sheet(filasPrograma(programa));
    hoja['!cols'] = [
      { wch: 12 },
      { wch: 18 },
      { wch: 45 },
      { wch: 22 },
      { wch: 22 },
      { wch: 10 },
      { wch: 16 },
      { wch: 10 },
      { wch: 28 },
      { wch: 14 },
      { wch: 14 },
      { wch: 14 },
      { wch: 18 },
      { wch: 18 },
      { wch: 22 },
      { wch: 22 },
      { wch: 18 },
      { wch: 26 },
      { wch: 18 },
      { wch: 18 },
      { wch: 16 },
      { wch: 16 },
      { wch: 30 },
    ];
    const nombre = nombreHojaUnico(programa, indice, usados);
    utils.book_append_sheet(workbook, hoja, nombre);
  });

  writeFile(workbook, `inscripciones_programas_${gestion}.xlsx`);
}
